import { useCallback, useState } from 'react';
import axios from 'axios';
import { useShowErrors } from '../../../hooks/useShowErrors';
import { CHECK_MFA_URL } from '../../../constants';
import { ICheckMfa } from '../../../interfaces/user';
import { ICheckMfaRes } from '../interfaces';

export const useAxiosMfaPassword = () => {
  const [loading, setLoading] = useState(false);
  const [res, setRes] = useState<ICheckMfaRes | null>(null);
  const [err, setErr] = useState<any>(null);

  const makeRequest = useCallback((data: ICheckMfa) => {
    setLoading(true);
    axios
      .post(CHECK_MFA_URL, data)
      .then(res => setRes(res.data))
      .catch(err => {
        if (err) setErr(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useShowErrors([err]);

  return { makeRequest, loading, res };
};
